/**
 * 获取微信支付配置信息
 */
export const WX_PAY_JSAPI = '/api/pay/weChat/jsApi';
/**
 * 跳转渠道支付完成页面
 */
export const PLATFORM_ORDER_OVER = '/api/v1/platform/redirectToOther';